import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FilterCollection, FilterNgMultiSelect, FilterValue, FilterValueCollection, EnumTypeDto } from '@hub/generated/models';
import { LookUps } from '@hub/common/LookUps';
import { getDepartmentLookUps } from '@tvPackages/services/tvp-permission.service';
import { CurrentUserService } from '@hub/services/CurrentUserService';

@Component({
  selector: 'f-filterNgMultiSelect',
  templateUrl: './filterNgMultiSelect.component.html',
  styleUrls: ['./filterNgMultiSelect.component.scss']
})
export class FilterNgMultiSelectComponent implements OnInit {
  constructor(
    private currentUserService: CurrentUserService
  ) { }

  @Input()
  public filter: FilterNgMultiSelect;

  private _filterCollection: FilterCollection;

  @Input()  set filterCollection(f: FilterCollection) {
      this._filterCollection = f;
      this.value = this.getValue();
  }
  get filterCollection() {
      return this._filterCollection;
  }

  @Input()
  public emptyValueText: string = 'Select...';

  @Input()
  public inline: boolean = false;

  @Output()
  public ondataChange: EventEmitter<FilterValueCollection> = new EventEmitter<FilterValueCollection>();

  public value: FilterValue[];
  public columnName: string;
  public source: FilterValue[];

  public ngOnInit() {
    this.columnName = this.filter.ColumnName;
    if (this.filter.Source === 'eTvPckgDepartment') {
      const roles = this.currentUserService.SecurityRoles.getValue();

      this.source = getDepartmentLookUps(roles).map(item => <FilterValue>{
        Key: item.value,
        Value: item.label
      });
    } else if (this.filter.Source === 'eTvPckgGenre') {
      const roles = this.currentUserService.SecurityRoles.getValue();

      let departments = getDepartmentLookUps(roles);
      let nonFilteredLookUps = LookUps.getEnumValuesForNgMultiselect(this.filter.Source, this.filter.IsGroup);

      this.source = nonFilteredLookUps.filter(c => departments.some(d => d.label === c.Description));
    } else {
      this.source = LookUps.getEnumValuesForNgMultiselect(this.filter.Source, this.filter.IsGroup);
    }
    this.value = this.getValue();
  }

  public onChange(event) {
    let result: FilterValueCollection = new FilterValueCollection();
    result.ColumnName = this.columnName;
    result.List = this.value;

    this.ondataChange.emit(result);
  }

  private getValue(): FilterValue[]
  {
    if (!!this.filterCollection && !!this.filterCollection.List) {
      let values = this.filterCollection.List.filter((item) => item.ColumnName == this.columnName)[0];
      if (!!values && !!values.List && !!values.List.length)
        return values.List;
    }

    return null;
  }

}
